import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import api from "../api";

export default function SmsReportPage() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [report, setReport] = useState(null);
  const [failedSms, setFailedSms] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchReport = async (userName) => {
    if (!userName) {
      alert("User is required");
      return;
    }
    if (!startDate || !endDate) {
      alert("Pick both start and end date");
      return;
    }

    setLoading(true);
    try {
      const res = await api.get(`/sms/report`, {
        params: {
          startDate: new Date(startDate).toISOString(),
          endDate: new Date(endDate).toISOString(),
        },
      });
      setReport(res.data);
      setFailedSms(res.data.failedSms);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch report");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div className="bg-white p-6 rounded shadow">
        <h2 className="text-xl font-semibold mb-4">SMS Report</h2>

        {/* Date Inputs */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
          <input
            type="datetime-local"
            onChange={(e) => setStartDate(e.target.value)}
            className="border rounded px-3 py-2"
          />
          <input
            type="datetime-local"
            onChange={(e) => setEndDate(e.target.value)}
            className="border rounded px-3 py-2"
          />
        </div>

        {/* Fetch Button */}
        <div className="flex gap-2 mb-6">
          <button
            onClick={fetchReport}
            disabled={loading}
            className="bg-emerald-600 text-white px-4 py-2 rounded"
          >
            {loading ? "Loading…" : "Get Report"}
          </button>
        </div>

        {/* Chart */}
        {report && (
          <div className="mt-6 bg-gray-50 rounded p-4">
            <h3 className="text-lg font-semibold mb-4 text-center">
              SMS Status Chart
            </h3>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={[
                  { name: "Queued", value: report.queuedCount ?? 0 },
                  { name: "Delivered", value: report.deliveredCount ?? 0 },
                  { name: "Failed", value: report.failedCount ?? 0 },
                  { name: "Rejected", value: report.rejectedCount ?? 0 },
                ]}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              >
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#10b981" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>

      {/* List of Failed SMS */}

      {/* List of Failed SMS */}
      {failedSms && failedSms.length > 0 && (
        <div className="bg-white p-6 rounded shadow mt-6">
          <h3 className="text-lg font-semibold mb-4 text-red-600">
            Failed SMS Details
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-100 text-sm uppercase text-gray-600">
                  <th className="p-3 border">Recipient</th>
                  <th className="p-3 border">Message</th>
                  <th className="p-3 border">Sent At</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {failedSms
                  .filter((sms) => {
                    // Safe check: ensures the message exists and doesn't contain the "1 recipient" tag
                    const msg = sms.recipient ? String(sms.recipient) : "";
                    return !msg.toLowerCase().includes("1 recipient");
                  })
                  .map((sms, index) => (
                    <tr
                      key={sms.id || index}
                      className="hover:bg-gray-50 text-sm"
                    >
                      <td className="p-3 border font-medium">
                        {sms.recipient}
                      </td>
                      <td className="p-3 border text-gray-600">
                        {sms.message}
                      </td>
                      <td className="p-3 border text-gray-600">{sms.sentAt}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
